import { useRouter } from '@hooks/useRouter';

type Role = 'clinician' | 'patient';

/**
 * @returns role either 'clinician' or 'patient'
 */
function useMyRole(): Role {
  const { pathname } = useRouter();

  return pathname.startsWith('/clinician') ? 'clinician' : 'patient';
}

export default useMyRole;
